<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Avaliar alterações fenotípicas"
    >
        <rkm-alert class="mt-0 mb-3">
            Uma alteração fenotípica deve ser considerada como <strong>presente</strong> quando esta for identificada na criança e foi presente em algum momento. Mesmo que
            esta sejaresolvida por meio cirúrgico, irá ser registrada como Presente em seu histórico.
        </rkm-alert>

        <rkm-form ref="RkmForm">
            <rkm-table
                :fields="fields"
                :items="model"
                hide-filters
                hide-pagination
            >
                <template v-slot:cell(resposta)="{item}">
                    <rkm-form-radio-group
                        :disabled="!item.permiteAlteracao || readonly"
                        v-model="item.isPresente"
                    >
                        <rkm-form-radio
                            :disabled="item.isRespondido"
                            :value="null"
                        >
                            Não informado
                        </rkm-form-radio>

                        <rkm-form-radio :value="false">Ausente</rkm-form-radio>
                        <rkm-form-radio :value="true">Presente</rkm-form-radio>
                    </rkm-form-radio-group>
                </template>
            </rkm-table>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    data: () => ({
        fields: [
            {key: 'descricao', label: 'Pergunta'},
            {key: 'status', label: 'Status'},
            {class: 'col-min', key: 'resposta', label: 'Resposta'},
        ],
        items: null,
        model: null,
    }),
    methods: {
        open(items) {
            this.items = items

            this.edit()

            this.$refs.RkmModal.show()
        },
        edit() {
            this.resetForm()

            this.model = this.clone(this.items)
        },
        update() {
            this.data.model.puericultura.alteracoesFenotipicas = this.model
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.update()

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model = null
        },
    },
    mixins: [object],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, default: false},
    },
}
</script>